module.exports = {
  MenuManagement: 'การจัดการเมนู',
  CustomerMenu: 'เมนูลูกค้า',
  CustomerAutomation: 'ระบบอัตโนมัติสำหรับลูกค้า',
  Search: 'ค้นหา',
  PleaseEnterChinese: 'กรุณาใส่ภาษาจีน ภาษาอังกฤษ หรือรหัส',
  AddMenu: 'เพิ่มเมนู',
  UpdateMenu: 'แก้ไขเมนู',
  AddCustomerMenu: 'เพิ่มเมนูลูกค้า',
  Refresh: 'รีเฟรช',
  ChineseName: 'ชื่อจีน',
  EnglishName: 'ชื่ออังกฤษ',
  Coding: 'รหัส',
  Icon: 'ไอคอน',
  Node: 'โหนด',
  ParentNode: 'โหนดหลัก',
  Order: 'ลำดับ',
  ModuleFile: 'ไฟล์โมดูล',
  H5Url: 'ที่อยู่ H5',
  Type: 'ประเภท',
  Module: 'โมดูล',
  Component: 'คอมโพเนนต์',
  Add: 'เพิ่ม',
  Update: 'แก้ไข',
  Save: 'บันทึก',
  Cancel: 'ยกเลิก',
  OK: 'ยืนยัน',
  ChineseCanNotBeEmpty: 'ชื่อจีนไม่สามารถเว้นว่างได้',
  EnglishCanNotBeEmpty: 'ชื่ออังกฤษไม่สามารถเว้นว่างได้',
  TheEncodingCanNotBeEmpty: 'รหัสไม่สามารถเว้นว่างได้',
  SavedSuccess: 'บันทึกสำเร็จ',
  PleaseSelectTheMenu: 'กรุณาเลือกเมนู',
  PleaseSelectTheCustomer: 'กรุณาเลือกลูกค้า',
  NoCustomersWantToAdd: 'ไม่มีลูกค้าที่จะเพิ่ม',
  Prompt: 'แจ้งเตือน',
  Removed: 'ลบออก',
  Numbering: 'เลขที่',
  delete: 'ลบ',
  CompanyChineseName: 'ชื่อภาษาจีน',
  SuccessfullyDeleted: 'ลบสำเร็จ',
  DeleteData: 'กรุณาเลือกลูกค้าที่ต้องการลบ',
  UpdateData: 'กรุณาเลือกลูกค้าที่ต้องการแก้ไขข้อมูล',
  InitData: 'กรุณาเลือกลูกค้าที่ต้องการดูข้อมูลพื้นฐานเริ่มต้น',
  SearchTitle: 'กรุณาใส่ชื่อบริษัทหรือรหัสบริษัทเพื่อค้นหา',
  BasicData: 'ข้อมูลพื้นฐาน',
  ExpiredCustomerNotification: 'แจ้งเตือนลูกค้าหมดอายุ',
  CompanyName: 'ชื่อบริษัท',
  CompanyCode: 'รหัสบริษัท',
  CompanyPhone: 'โทรศัพท์บริษัท',
  CompanyEMail: 'อีเมลบริษัท',
  CompanyFax: 'แฟกซ์บริษัท',
  CreateDate: 'เวลาที่สร้าง',
  GroupCompany: 'บริษัทกลุ่ม',
  InitializeCustomer: 'บริษัทที่จดทะเบียน',
  copy: 'กรุณาเลือกสภาพแวดล้อมที่ต้องการคัดลอก',
  InitializeData: 'เริ่มต้นข้อมูลพื้นฐาน',
  InitializeMenu: 'เริ่มต้นเมนู',
  CompanyNamePrompt: 'ชื่อบริษัทต้องกรอก',
  mailbox: 'อีเมลผู้ดูแลระบบต้องกรอก',
  UpdateSuccess: 'แก้ไขข้อมูลสำเร็จ',
  Initialized: 'เริ่มต้นสำเร็จ',
  CompanyAddress: 'ที่อยู่บริษัท',
  AdminChineseName: 'ชื่อภาษาจีนของผู้ดูแลระบบ',
  AdminEnglishName: 'ชื่อภาษาอังกฤษของผู้ดูแลระบบ',
  email: 'อีเมลผู้ดูแลระบบ',
  phone: 'โทรศัพท์ผู้ดูแลระบบ',
  Current: 'รหัสบริษัท',
  StandardLibrary: 'สภาพแวดล้อมมาตรฐาน',
  Next: 'ขั้นตอนต่อไป',
  Back: 'ขั้นตอนก่อนหน้า',
  Finish: 'เสร็จสิ้น',
  Initialize: 'เริ่มต้น',
  Harbour: 'ท่าเรือ',
  Airport: 'สนามบิน',
  ChargesItems: 'รายการค่าใช้จ่าย',
  AirRoute: 'เส้นทางเดินเรือ/เที่ยวบิน',
  NetWork: 'เครือข่าย',
  Currency: 'สกุลเงิน',
  EQType: 'ประเภทตู้คอนเทนเนอร์',
  Packing: 'บรรจุภัณฑ์',
  HouseBlType: 'ประเภทใบตราส่งสินค้า',
  CargoType: 'ประเภทสินค้า',
  IncoTerm: 'ข้อตกลงทางการค้า',
  ShippingTerm: 'ข้อตกลงการขนส่ง',
  TradeTerm: 'วิธีการค้า',
  CustomerType: 'ประเภทลูกค้า',
  PortGroup: 'ท่าเรือที่เกี่ยวข้อง',
  OtherChargeItem: 'ค่าบริการเพิ่มเติมใบตราส่งสินค้าทางอากาศ',
  ShippingCompaniesAirlines: 'บริษัทเรือ/สายการบิน',
  Template: 'เทมเพลต',
  AirService: 'รายการบริการค่าขนส่งทางอากาศ',
  BlMode: 'วิธีการออกใบตราส่งสินค้า',
  CustomJobType: 'ประเภทธุรกิจที่กำหนดเอง',
  TransmitFileType: 'ประเภทเอกสารหมุนเวียน',
  copyTenantId: 'กรุณาเลือกสภาพแวดล้อมที่ต้องการคัดลอก',
  imgToolTip: 'กรอกข้อมูลบริษัทและผู้ดูแลระบบ\nอีเมลผู้ดูแลระบบเป็นข้อมูลเข้าสู่ระบบ',
  imgToolTip2: 'เทมเพลตที่ต้องการคัดลอก',
  imgToolTip3: 'ข้อมูลพื้นฐานของแพลตฟอร์ม',
  imgToolTip4: 'เมนูแพลตฟอร์ม',
  Sequence: 'ลำดับ',
  documentCategory: 'การจัดการประเภทเอกสาร',
  charegeUnit: 'หน่วยการคิดเงิน/หน่วย',
  BusinessStatus: 'การจัดการสถานะธุรกิจ',
  PermissionConfig: 'การกำหนดค่าสิทธิ์',
  Report: 'รายงาน',
  ConfigurationManagement: 'การจัดการการกำหนดค่า',
  SingleOnlineSet: 'การตั้งค่าการตรวจสอบใบสั่งออนไลน์',
  IsH5Open: 'H5 เปิดให้บริการหรือไม่',
  CopySetting: 'คัดลอกการกำหนดค่า',
  AllOpen: 'เปิดให้บริการทั้งหมด',
  AllClose: 'ไม่เปิดให้บริการทั้งหมด',
  Start: 'เริ่มต้น',
  StandardLibrary2: 'คลังมาตรฐาน',
  OnlineCustomerService: 'บริการลูกค้าออนไลน์',
  SubmitATicket: 'ส่งใบงาน',
  CheckTheTicket: 'ดูใบงาน',
  Menu1: 'เมนู',
  HelpCenter: 'ศูนย์ช่วยเหลือ',
  HelpVideo: 'วิดีโอช่วยเหลือ',
  SystemOperationGuidance: 'คำแนะนำการใช้งานระบบ',
  InitializeBoot: 'คำแนะนำการเริ่มต้นใช้งาน',
  SpareQQ: 'QQ สำรอง',
  SettingsAndTools: 'การตั้งค่าและเครื่องมือ',
  ReportStatistics: 'สถิติรายงาน',
  Weibo: 'เวยโบ๋',
  LogInformation: 'ข้อมูลบันทึก',
  BillingSystem: 'ระบบการคิดเงิน',
  UnbindWeChat: 'ยกเลิกการผูกบัญชี WeChat',
  SystemInformation: 'ข้อมูลระบบ',
  SignOut: 'ออกจากระบบ',
  WallTechFamily: 'โว๋สิงโฮม',
  Notice: 'เตือน',
  ClearLog: 'ลบบันทึก',
  UploadLog: 'อัปโหลดบันทึก',
  AuthorizationToken: 'โทเค็นการอนุญาต:',
  LogLevel: 'ระดับบันทึก:',
  Source: 'แหล่งที่มา',
  AccountInformation: 'ข้อมูลบัญชี',
  ShowYourAccountNumberAndTheCompaniesAndDepartmentsToWhichYouBelongHere: 'ที่นี่แสดงบัญชีของคุณและบริษัท/แผนกที่สังกัด',
  InStationMessageReminder: 'การแจ้งเตือนข้อความภายในเว็บ',
  WhenYouHaveAPendingTaskThereWillBeAToDoNumberOnTheBellToRemindYouToDealWithItInTime: 'เมื่อคุณมีงานที่รอดำเนินการ กระดิ่งจะแสดงจำนวนเพื่อเตือนให้คุณดำเนินการทันเวลา',
  ClickHereToEnterWallTechFamilyToViewYourOrderTrainingVideosAndOtherInformation: 'คลิกที่นี่เพื่อเข้าสู่โว๋สิงโฮม ดูข้อมูลคำสั่งซื้อและวิดีโอฝึกอบรมของคุณ',
  WhenYouEncounterProblemsWithYourOperatingSystemYouCanContactOurOnlineCustomerServiceAtAnyTime: 'เมื่อคุณมีปัญหาในการใช้งานระบบ สามารถติดต่อฝ่ายบริการลูกค้าออนไลน์ของเราได้ตลอดเวลา',
  MultilingualSwitching: 'การเปลี่ยนภาษา',
  SwitchDifferentLanguages: 'เปลี่ยนเป็นภาษาต่างๆ',
  HereIsAHelpfulCenterSystemRelatedConfigurationToolsReportStatisticsBillingSystemAndOtherMoreInformation: 'ที่นี่มีศูนย์ช่วยเหลือ เครื่องมือการตั้งค่าระบบ สถิติรายงาน ระบบการคิดเงิน และข้อมูลอื่นๆ',
  OperationArea: 'พื้นที่ทำงาน',
  HereIsTheOperationInterfaceForYourDailyWork: 'ที่นี่เป็นอินเทอร์เฟซการทำงานประจำวันของคุณ',
  MenuBar: 'แถบเมนู',
  TheSystemModuleMenuBarDisplayedHereMatchesThePermissionsOfYourLoginAccount: 'ที่นี่แสดงแถบเมนูโมดูลระบบที่สอดคล้องกับสิทธิ์ของบัญชีที่คุณเข้าสู่ระบบ',
  More: 'เพิ่มเติม',
  Skip: 'ข้าม',
  WeChatUnbindingFailed: 'ยกเลิกการผูกบัญชี WeChat ไม่สำเร็จ',
  WhetherToConfirmWeChatUnbinding: 'ยืนยันที่จะยกเลิกการผูกบัญชี WeChat หรือไม่?',
  Unbind: 'ยกเลิกการถอดผูกพัน',
  WeChatUnbindingSuccessfully: 'ยกเลิกการผูกบัญชี WeChat สำเร็จแล้ว',
  DearYouHaventBoundYourWeChatAccountYet: 'คุณยังไม่ได้ผูกบัญชี WeChat',
  AdministratorInitializationOperationGuidance: 'คำแนะนำการตั้งค่าเริ่มต้นสำหรับผู้ดูแลระบบ',
  ImproveEnterpriseInformation: 'ปรับปรุงข้อมูลบริษัท',
  PleaseImproveYourCompanyEnterpriseInformation: 'กรุณากรอกข้อมูลบริษัทของท่านให้ครบถ้วน',
  CreateAUser: 'สร้างผู้ใช้',
  CreateOurUsersAndSetPermissions: 'สร้างผู้ใช้ของบริษัทและกำหนดสิทธิ์',
  CustomerDataImport: 'นำเข้าข้อมูลลูกค้า/คู่ค้า',
  InitializeAndImportTheCompanyOriginalCustomerInformation: 'นำเข้าข้อมูลลูกค้า/คู่ค้าเดิมของบริษัทเริ่มต้น',
  ViewTheSteps: 'ดูขั้นตอนการดำเนินการ',
  YouAreNotAuthorizedToUseStatisticalAnalysisFunction: 'คุณไม่มีสิทธิ์ใช้งานฟังก์ชันวิเคราะห์สถิติ'
}
